import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Admin from '@store/admin';

import { AdminNotificationTemplates } from '@components/admin/AdminNotificationTemplates';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    Admin.actionCreators,
)(AdminNotificationTemplates as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
